import { Component } from '@angular/core';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'app-sidebar-menu',
  imports: [MenuComponent],
  template: `
  <div class="layout-sidebar bg-primary">
    <img src="images/logo/logo_sapienza_white.png" class=" max-h-[12rem]" />
    <div class="flex-1 min-h-0"><app-menu></app-menu></div>

</div>
  `

})
export class SidebarMenuComponent {

}
